module.exports = __webpack_public_path__ + "img/gjyx.cd69cd13.png";